/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type Builder_proposal$ref = any;
type Delete_proposal$ref = any;
type ProposeNowContainer_proposal$ref = any;
export type ProposalReviewStatus = "IN_DRAFT" | "NONE" | "OPEN_PROPOSALS_IN_YOUR_CIRCLES" | "TO_REVIEW";
export type ProposalStatus = "ACCEPTED" | "DRAFT" | "DRAFT_WITH_CONFLICTS" | "ESCALATED" | "PROPOSED_OUTSIDE_MEETING";
export type TensionMeetingType = "GOVERNANCE" | "TACTICAL";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Modal_proposal$ref: FragmentReference;
declare export opaque type Modal_proposal$fragmentType: Modal_proposal$ref;
export type Modal_proposal = {|
  +databaseId: string,
  +status: ProposalStatus,
  +expectedResponseCount: number,
  +reviewStatus: ProposalReviewStatus,
  +changes: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +databaseId: string
      |}
    |}>
  |},
  +tension: ?{|
    +databaseId: string,
    +agendaLabel: ?string,
    +meetingType: ?TensionMeetingType,
  |},
  +$fragmentRefs: Builder_proposal$ref & Delete_proposal$ref & ProposeNowContainer_proposal$ref,
  +$refType: Modal_proposal$ref,
|};
export type Modal_proposal$data = Modal_proposal;
export type Modal_proposal$key = {
  +$data?: Modal_proposal$data,
  +$fragmentRefs: Modal_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "changes"
        ]
      }
    ]
  },
  "name": "Modal_proposal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expectedResponseCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewStatus",
      "storageKey": null
    },
    {
      "alias": "changes",
      "args": null,
      "concreteType": "DescribeChangeableConnection",
      "kind": "LinkedField",
      "name": "__ChangeList_changes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DescribeChangeableEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Tension",
      "kind": "LinkedField",
      "name": "tension",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agendaLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Builder_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Delete_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposeNowContainer_proposal"
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '4e43ec46bdfba8ab32bcd8fd138e318a';

module.exports = node;
